import { BaseModel, SearchParameter } from './base.model';

export class PrivateChat extends BaseModel {
    totalMembers?: number;
    userIdList?: Array<string>;
}

export class PrivateChatSearchParameter extends SearchParameter {
    totalMembers?: string;
  }